import { Truck, Clock, Shield, Award } from 'lucide-react';

const Hero = ({ onBookNow }) => {
  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden pt-32">
      {/* Background with overlay */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://images.unsplash.com/photo-1616432043562-3671ea2e5242?w=1920&q=80" 
          alt="Professional truck service"
          className="w-full h-full object-cover opacity-30"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="animate-fade-in">
          <h1 className="text-4xl md:text-7xl font-bold mb-6 leading-tight">
            <span className="text-white block">Calgary's Premier</span>
            <span className="gold-gradient block">Delivery & Hauling Service</span>
          </h1>
          <p className="text-xl md:text-2xl text-gray-300 mb-8 max-w-3xl mx-auto">
            Affordable. Fast. Reliable. Alberta Strong.
          </p>
          <p className="text-lg text-gray-400 mb-12 max-w-2xl mx-auto">
            Locally owned and operated. Registered and insured. Serving Calgary and surrounding areas with professional delivery and hauling solutions.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-16">
            <button 
              onClick={() => onBookNow()}
              className="bg-[#d4af37] text-black px-8 py-4 rounded-lg text-lg font-bold hover:bg-[#b8941f] transition transform hover:scale-105"
              data-testid="hero-book-button"
            >
              Book Service Now
            </button>
            <a 
              href="tel:4038014638"
              className="bg-transparent border-2 border-[#d4af37] text-[#d4af37] px-8 py-4 rounded-lg text-lg font-bold hover:bg-[#d4af37] hover:text-black transition"
              data-testid="hero-call-button"
            >
              Call (403) 801-4638
            </a>
          </div>
        </div>

        {/* Features */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-16">
          <div className="text-center" data-testid="feature-24-7">
            <Clock className="w-12 h-12 mx-auto mb-3 text-[#d4af37]" />
            <h3 className="font-bold text-lg">24/7 Available</h3>
            <p className="text-gray-400 text-sm">Always ready to serve</p>
          </div>
          <div className="text-center" data-testid="feature-insured">
            <Shield className="w-12 h-12 mx-auto mb-3 text-[#d4af37]" />
            <h3 className="font-bold text-lg">Fully Insured</h3>
            <p className="text-gray-400 text-sm">Registered & protected</p>
          </div>
          <div className="text-center" data-testid="feature-local">
            <Award className="w-12 h-12 mx-auto mb-3 text-[#d4af37]" />
            <h3 className="font-bold text-lg">Local Business</h3>
            <p className="text-gray-400 text-sm">Calgary owned & operated</p>
          </div>
          <div className="text-center" data-testid="feature-professional">
            <Truck className="w-12 h-12 mx-auto mb-3 text-[#d4af37]" />
            <h3 className="font-bold text-lg">Professional</h3>
            <p className="text-gray-400 text-sm">Reliable & efficient</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;